<template>
<b-col md="6">
  <div class="my-2">
    <b-card
    @click="openLink(href)"
      overlay
      :img-src="'https://api.kllaar.com/public/udemy/'+cover"
      :img-alt="title"
      text-variant="white"
      class="link"
    >
    </b-card>
  </div>
</b-col>
</template>
<script>
export default {
  props: {
    cover: String,
    title: String,
    href: String
  },
  methods:{
      openLink(){
          window.open(this.href, '_blank');

      }
  }
};
</script>
<style scoped>
.link{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/#public/curse/components/home/ExternalCourseItem.vue